var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 2.25C11.3203 2.25 12 2.92969 12 3.75V9.75C12 10.5938 11.3203 11.25 10.5 11.25H1.5C0.65625 11.25 0 10.5938 0 9.75V3.75C0 2.92969 0.65625 2.25 1.5 2.25H3V1.5C3 0.679688 3.65625 0 4.5 0H7.5C8.32031 0 9 0.679688 9 1.5V2.25H10.5ZM4.5 1.125C4.28906 1.125 4.125 1.3125 4.125 1.5V2.25H7.875V1.5C7.875 1.3125 7.6875 1.125 7.5 1.125H4.5ZM1.5 3.375C1.28906 3.375 1.125 3.5625 1.125 3.75V6H10.875V3.75C10.875 3.5625 10.6875 3.375 10.5 3.375H1.5ZM10.5 10.125C10.6875 10.125 10.875 9.96094 10.875 9.75V7.125H7.5V7.5C7.5 7.92188 7.14844 8.25 6.75 8.25H5.25C4.82812 8.25 4.5 7.92188 4.5 7.5V7.125H1.125V9.75C1.125 9.96094 1.28906 10.125 1.5 10.125H10.5Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.de99cdd9420af8c683bb1993854620b6.svg";
export { ForwardRef as ReactComponent };